import { render, staticRenderFns } from "./Market.vue?vue&type=template&id=34a62e13&scoped=true&"
import script from "./Market.vue?vue&type=script&lang=ts&"
export * from "./Market.vue?vue&type=script&lang=ts&"
import style0 from "./Market.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Market.vue?vue&type=style&index=1&id=34a62e13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a62e13",
  null
  
)

export default component.exports